module.exports = __webpack_public_path__ + "static/img/baiduyun.a2d8f899.png";